interface AutoChargeCheckboxProps {
  checked: boolean;
  onChange: (value: boolean) => void;
}

export function AutoChargeCheckbox({ checked, onChange }: AutoChargeCheckboxProps) {
  return (
    <div className="space-y-2">
      <label className="flex cursor-pointer items-start gap-3">
        <span
          data-testid="auto-charge-checkbox"
          role="checkbox"
          aria-checked={checked}
          tabIndex={0}
          onClick={() => onChange(!checked)}
          onKeyDown={(e) => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); onChange(!checked); } }}
          className={`mt-0.5 flex h-4 w-4 flex-shrink-0 cursor-pointer items-center justify-center rounded border transition ${
            checked
              ? 'border-[var(--color-primary)] bg-[var(--color-primary)]'
              : 'border-slate-300 bg-white'
          }`}
        >
          {checked && (
            <svg viewBox="0 0 12 12" className="h-3 w-3 text-white" fill="none" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M2.5 6l2.5 2.5 4.5-5" />
            </svg>
          )}
        </span>
        <span className="text-xs text-slate-600">
          Autorizo cobranças automáticas de pedidos excedentes no cartão cadastrado
        </span>
      </label>
      {!checked && (
        <p className="rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800">
          Sem cobrança automática, você receberá uma fatura e terá 3 dias úteis para pagar.
          Após o vencimento, o cardápio será temporariamente bloqueado para novos pedidos.
        </p>
      )}
    </div>
  );
}
